module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT ParaOverride-11",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("From time to time, God causes men to be born—and thou art one of them—who have a lust to go abroad at the risk of their lives and discover news—today it may be of far-off things, tomorrow of some hidden mountain, and the next day of some nearby men who have done a foolishness against the state. These souls are very few; and of these few, not more than ten are of the best.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-16"
  }, [_vm._v("—Kim, ")]), _c('span', {
    staticClass: "CharOverride-17"
  }, [_vm._v("Rudyard Kipling")])]), _vm._v(" "), _c('p', {
    staticClass: "CAP ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/C01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "CAP"
  }, [_c('span', {
    staticClass: "CharOverride-18"
  }, [_vm._v("“That Africa is now but a memory . . .”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670b0638","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V28915.vue
// module id = 78
// module chunks = 0